import { ElementType } from "../../dom-tools/ElementType";
import { EventListenerCache } from "../basics/EventListenerCache";
import { GraphicalElement } from "../graphical/GraphicalElement";
import { LinkedGraphicalElement } from "../graphical/LinkedGraphicalElement";
import { UIProperty } from "../basics/UIProperty";
import { link } from "fs-extra";
import { isClassOf } from "../../tools/TypeUtilities";
import { LinkedGraphicalElementList } from "../graphical/LinkedGraphicalElementList";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { UICursorAsset } from "../basics/UICursors";


export abstract class UIComponent extends GraphicalElement
{  
  static readonly flag = new ClassFlag( "ui--component" );
  static readonly debug = new ClassFlag( "debug" );
  
  static #lockCursor:( t:string ) => void = ()=>{} ;
 
  static lockCursor( type:string|Element )
  {
    console.log( "LOCKING CURSOR:", type );
    let stringType = type + "";

    if ( typeof type !== "string" )
    {
      stringType = getComputedStyle( type as Element ).cursor;
    }

    UIComponent.#lockCursor( stringType );
  } 


  static #freeCursor:() =>void = ()=>{} ;;
  static freeCursor()
  {
    UIComponent.#freeCursor();
  }

  static setCursorLocking( lock:( t:string )=>void, free:()=>void )
  {
    this.#lockCursor = lock;
    this.#freeCursor = free;
  }

  static readonly placeHolder = new ElementType( "ui--placeholder" );
  protected readonly _events = new EventListenerCache();
  protected _linkedGraphicalElements:LinkedGraphicalElement<any>[] = [];
  protected _linkedGraphicalElementLists:LinkedGraphicalElementList<any>[] = [];
  protected _singlPlaceHolders:Element[] = [];
  protected _listPlaceHolders:Element[] = [];
  protected _allPlaceHolders:Element[] = [];

  protected _setElement( element:Element, classFlag:ClassFlag = GraphicalElement.flag )
  {
    super._setElement( element, classFlag );

    UIComponent.flag.set( element );

  }
  _addPlaceHolder( element:Element )
  {
    if ( this.element )
    {
      this.element.appendChild( element );

      return;
    }

    this._allPlaceHolders.push( element );   
  }

  _onElementCreated()
  {
    this._allPlaceHolders.forEach( p => this.element.appendChild( p ) );
  }


  _addLinkedGraphicalElement( linkedElement:LinkedGraphicalElement<any> )
  {
    if ( linkedElement.parent !== this )
    {
      return;
    }

    this._linkedGraphicalElements.push( linkedElement );
    let placeHolder = UIComponent.placeHolder.create();
    this._singlPlaceHolders.push( placeHolder );
    
    this._addPlaceHolder( placeHolder );
  }

  _addLinkedGraphicalElementList( linkedElementList:LinkedGraphicalElementList<any> )
  {
    if ( linkedElementList.parent !== this )
    {
      return;
    }

    this._linkedGraphicalElementLists.push( linkedElementList );    
    let placeHolder = UIComponent.placeHolder.create();
    linkedElementList._setParentContainer( this, placeHolder as HTMLElement );
    this._listPlaceHolders.push( placeHolder );

    this._addPlaceHolder( placeHolder );
  }

  _addElementOfLinked( linked:LinkedGraphicalElement<any>, element:Element )
  {
    let index = this._linkedGraphicalElements.indexOf( linked );
    let placeHolder = this._singlPlaceHolders[ index ];
    this.element.replaceChild( element, placeHolder );
  }

  _removeElementOfLinked( linked:LinkedGraphicalElement<any>, element:Element )
  {
    let index = this._linkedGraphicalElements.indexOf( linked );
    let placeHolder = this._singlPlaceHolders[ index ];

    this.element.replaceChild( placeHolder, element );
  }

  _dispatchOnChange( linked:LinkedGraphicalElement<any>, ...properties:UIProperty<any>[] )
  {
    linked.addListener(
      ()=>
      {
        properties.forEach( p => p.forceDispatch() );
      }
    );
  }

  _updateChildren()
  {
    this._linkedGraphicalElements.forEach( 
      lge => 
      {
        let value:GraphicalElement = lge.value;

        if ( value == null )
        {
          return;
        }

        value.redraw();
      }
    );

    this._linkedGraphicalElementLists.forEach( 
      list => 
      {
        list.forAll( l => l.redraw() );
      }
    );
  }

  updatePropertiesSilent()
  {
    this.blockRedraw();
    this._properties.forEach( p => p.forceDispatch() );
    this.allowRedraw();
  }
}